const PodcastsLoading = () => {
    return (
        <div>
            <div className="h-10 w-full l-load mb-3"></div>
            <div className="grid grid-cols-2 gap-4 container max-lg:grid-cols-1">
                <div>
                    {
                        [...Array(3)].map((_, index) => (
                            <div key={index} className="l-load rounded-md p-4 mb-3">
                                <div className="h-auto w-full gap-4 p-4" style={{ display: 'flex' }}>
                                    <div className="size-24 rounded-md l-load-dt"></div>
                                    <div className="space-y-2 flex flex-col ">
                                        <div className="w-48 h-4 l-load-dt"></div>
                                        <div className="w-40 h-4 l-load-dt"></div>

                                    </div>
                                </div>
                                <div className="w-full justify-between gap-2 items-end" style={{ display: 'flex' }}>
                                    <div className="w-full space-y-2">
                                        <div className="w-11/12 h-3 l-load-dt"></div>
                                        <div className="w-3/4 h-3 l-load-dt"></div>
                                    </div>
                                    <div className="w-16 h-3 l-load-dt"></div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className=" rounded-md">
                    {
                        [...Array(4)].map((_, index) => (
                            <div key={index} className="l-load rounded-md p-4 mb-3">
                                <div className="h-auto w-full gap-4 p-4" style={{ display: 'flex' }}>
                                    <div className="size-24 rounded-md l-load-dt"></div>
                                    <div className="space-y-2 flex-col" style={{ display: 'flex' }}>
                                        <div className="w-48 h-4 l-load-dt"></div>
                                        <div className="w-40 h-4 l-load-dt"></div>
                                        <div className="w-32 h-4 l-load-dt"></div>
                                    </div>
                                </div>
                                <div className="w-full space-y-2">
                                    {[...Array(4)].map((_, i) => (
                                        <div key={i} className={`w-full h-3 l-load-dt`}></div>
                                    ))}
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>
        </div>
    )
};
export default PodcastsLoading